import { axiosPrivate } from 'app/utils';
import helpers from './helpers';

export default {
  async sendEvent(pharmacyId, screen, action, options = {}) {
    const response = await axiosPrivate.post(`/events/connect/${pharmacyId}`, { 
      ...options,
      screen, 
      action,
    });

    if (response.data.error) helpers.throwError(response.data.error);
    return response.data;
  },
};
